import React, { Fragment } from 'react';
import MultiDetailDrillDown from 'components/multiDetailDrillDown';
import IntlMessages from 'util/IntlMessages';
import { formatBalance } from 'services/NumberFormatters';

/**
 * 
 * @param {Array} data of value stream objects
 */
const ValueStreamDrillDown = ({ data }) => {
    let entries = new Array();
    if (Array.isArray(data)) {
        // need to convert data to label, description objects for use by basicDetailDrillDown
        entries = data.map((entry) => {
            return {
                name: entry?.name,
                drillDownData: [
                    { label: <IntlMessages id="label.description" />, description: entry?.description ? entry?.description : 'no description specified' },
                    { label: <IntlMessages id="label.valueProposition" />, description: entry?.valueProposition ? entry?.valueProposition : 'no value proposition specified' },
                    { label: <IntlMessages id="label.budget" />, description: entry?.budget ? formatBalance(entry?.budget) : formatBalance(0) },
                    { label: <IntlMessages id="label.kpi" />, description: entry?.kpi ? entry?.kpi : 'no kpi specified' },
                    { label: <IntlMessages id="label.systems" />, description: entry?.systems ? entry?.systems : 'no systems specified' },
                    { label: <IntlMessages id="label.owner" />, description: entry?.owner ? entry?.owner : 'no owner specified' },
                    { label: <IntlMessages id="label.theme" />, description: entry?.theme ? entry?.theme : 'no theme specified' },
                ]
            };
        });
        return (
            <div>
                <MultiDetailDrillDown entries={entries} />
            </div>
        );
    }
    return (
        <Fragment></Fragment>
    );
};

export default ValueStreamDrillDown;


// WEBPACK FOOTER //
// ./components/agileDrillDowns/valueStreamDrillDown/index.js